import React, { useState } from 'react';
import { Tag, ExternalLink, X, ShoppingCart, ChevronDown, ChevronUp } from 'lucide-react';
import { CENTR_PRODUCTS, CENTR_BUNDLES, CENTR_DISCOUNT, CENTR_LINKS } from '../lib/centrAffiliateData';

const FEATURED = [
  CENTR_PRODUCTS.find(p => p.id === 'sled'),
  CENTR_PRODUCTS.find(p => p.id === 'kettlebells'),
  CENTR_PRODUCTS.find(p => p.id === 'wallBalls'),
  CENTR_PRODUCTS.find(p => p.id === 'rope'),
].filter(Boolean);

export const CentrInlineCTA = () => (
  <div className="my-8 bg-zinc-900/80 border border-[#e8ff00]/20 p-5" data-testid="centr-inline-cta">
    <div className="flex items-center gap-3 mb-3">
      <Tag className="w-4 h-4 text-[#e8ff00]" />
      <span className="text-white text-sm font-heading">CENTR x HYROX — Save {CENTR_DISCOUNT.percent}%</span>
      <span className="text-[10px] bg-[#e8ff00] text-black uppercase tracking-wider font-heading px-2 py-0.5">
        Code: {CENTR_DISCOUNT.code}
      </span>
    </div>
    <p className="text-zinc-400 text-xs mb-4">Train on official competition equipment. Exclusive NinjAthlete pricing on all CENTR x HYROX gear.</p>
    <div className="flex flex-wrap gap-2">
      {FEATURED.map(p => (
        <a key={p.id} href={p.url} target="_blank" rel="sponsored noopener noreferrer"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-zinc-800 border border-zinc-700 hover:border-[#e8ff00]/40 text-xs text-zinc-300 hover:text-[#e8ff00] transition-colors"
          data-testid={`centr-inline-${p.id}`}>
          {p.name.replace('CENTR x HYROX ', '')} <ExternalLink className="w-3 h-3" />
        </a>
      ))}
      <a href={CENTR_LINKS.home} target="_blank" rel="sponsored noopener noreferrer"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#e8ff00] text-black text-xs font-heading uppercase tracking-wider hover:opacity-90 transition-opacity"
        data-testid="centr-inline-shop-all">
        Shop All <ExternalLink className="w-3 h-3" />
      </a>
    </div>
  </div>
);

export const CentrStickyPopup = ({ onClose }) => {
  const [expanded, setExpanded] = useState(false);
  const items = expanded ? [...CENTR_PRODUCTS.slice(0, 6), ...CENTR_BUNDLES.slice(0, 2)] : FEATURED;

  return (
    <div className="fixed bottom-4 right-4 z-40 w-80 bg-[#0a0a0a] border border-[#e8ff00]/30 shadow-2xl shadow-black/50" data-testid="centr-popup">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-800 bg-[#e8ff00]/5">
        <div className="flex items-center gap-2">
          <ShoppingCart className="w-4 h-4 text-[#e8ff00]" />
          <span className="text-white text-xs font-heading uppercase tracking-wider">HYROX Equipment</span>
        </div>
        <div className="flex items-center gap-1">
          <span className="text-[9px] bg-[#e8ff00] text-black uppercase tracking-wider font-heading px-1.5 py-0.5">
            {CENTR_DISCOUNT.percent}% OFF
          </span>
          <button onClick={onClose} className="text-zinc-500 hover:text-white transition-colors p-1 ml-1" data-testid="centr-popup-close">
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      {/* Products */}
      <div className="max-h-60 overflow-y-auto">
        {items.map(p => (
          <a key={p.id} href={p.url} target="_blank" rel="sponsored noopener noreferrer"
            className="flex items-center justify-between px-4 py-2.5 border-b border-zinc-800/50 hover:bg-zinc-800/50 transition-colors group"
            data-testid={`centr-popup-item-${p.id}`}>
            <div className="min-w-0 flex-1">
              <p className="text-white text-xs font-heading group-hover:text-[#e8ff00] transition-colors truncate">{p.name}</p>
              <p className="text-zinc-600 text-[10px]">{p.price}</p>
            </div>
            <ExternalLink className="w-3 h-3 text-zinc-600 group-hover:text-[#e8ff00] flex-shrink-0 ml-2" />
          </a>
        ))}
      </div>

      {/* Expand / Code */}
      <div className="px-4 py-3 border-t border-zinc-800">
        <div className="flex items-center justify-between mb-2">
          <p className="text-zinc-500 text-[10px]">
            Code: <span className="text-[#e8ff00] font-heading">{CENTR_DISCOUNT.code}</span>
          </p>
          <button onClick={() => setExpanded(!expanded)} className="text-zinc-500 hover:text-[#e8ff00] text-[10px] font-heading uppercase tracking-wider flex items-center gap-1 transition-colors">
            {expanded ? <>Less <ChevronUp className="w-3 h-3" /></> : <>More <ChevronDown className="w-3 h-3" /></>}
          </button>
        </div>
        <a href={CENTR_LINKS.home} target="_blank" rel="sponsored noopener noreferrer"
          className="block w-full text-center px-3 py-2 bg-[#e8ff00] text-black text-xs font-heading uppercase tracking-wider hover:opacity-90 transition-opacity"
          data-testid="centr-popup-shop-all">
          Shop All CENTR Equipment
        </a>
      </div>
    </div>
  );
};
